import React, { useState } from "react";
import { Route, Routes } from "react-router-dom";
import styled from "styled-components";
import * as Router from "../../Routes";
import Dashboard from "../../Pages/Dashboard/Dashboard";
import { ProfileLeftbar } from "../../Pages/ProfileLeftbar/ProfileLeftbar";
import Profile from "../../Pages/Profile/Profile";
import CreateNfts from "../../Pages/CreateNfts/CreateNfts";
import MyCollection from "../../Pages/Revenue Streams/Revenuestreams";
import RightBackgroundImage from "../../Images/backgroundImage.jpg";

import { Footer } from "../Footer/Footer";
import Revenuestreams from "../../Pages/Revenue Streams/Revenuestreams";
import NftMintData from "../../Pages/NFTMintData/NftMintData";
import ListingNft from "../../Pages/ListingNft/ListingNft";
import Wallet from "../../Pages/Wallet/Wallet";
import SearchTopbar from "../../Pages/SearchTopBar/SearchTopbar";
import ManageCurrency from "../../Pages/ManageCurrency/ManageCurrency";
import { userInfoContext } from "../../Context/userInfoContext";
import { userProviderContext } from "../../Context/userProviderContext";
const Root = styled.div`
  width: 100%;
  min-height: 100vh;
  color: ${(p) => p.theme.colors.white};
  position: relative;
  font-family: ${(p) => p.theme.font.family.Lato};
  font-stretch: normal;
  font-style: normal;
  background-color: white;
  @media (max-width: 768px) {
    background-color: black;
    background-color: white;
  }
`;

const Image = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  position: fixed;
  opacity: 0.07;
  top: 0;
  left: 0;
  z-index: 1;
`;
const Container = styled.div`
  position: relative;
  z-index: 10;
  display: flex;
  flex-direction: row;
  z-index: 11;
  @media (max-width: ${(p) => p.theme.screen.sm}) {
    flex-direction: column-reverse;
  }
`;
const Div = styled.div`
  width: 100%;
`;
const LeftImage = styled.img`
  position: fixed;
  top: 0px;
  left: 0px;
  z-index: -1;
  width: fit-content;
  height: 500px;
  @media (max-width: ${(p) => p.theme.screen.xxs}) {
    height: 300px;
  }
`;
const RightImage = styled.img`
  position: fixed;
  right: 0px;
  z-index: -1;
  width: fit-content;
  bottom: 0px;
  height: 500px;
  @media (max-width: ${(p) => p.theme.screen.xxs}) {
    height: 300px;
  }
`;
const LeftWrapper = styled.div`
  width: 300px;
`;
const RightWrapper = styled.div`
  width: 100%;
  /* background-image: url("RightBackgroundIMage"); */
`;
const App = () => {
  const [allContractDetails, setAllContractDetails] = useState({});
  const [userToken,setUserToken]=useState(localStorage.getItem('userinfo'));
  const [userProvider,setUserProvider]=useState(localStorage.getItem("provider"));
  // const [showNavigation,setShowNavigation] = useState(false);
  return (
    <userProviderContext.Provider value={{userProvider,setUserProvider}}>
      <userInfoContext.Provider value={{userToken,setUserToken}}>
      <Root>
      <Container>
        <LeftWrapper>
          <ProfileLeftbar />
        </LeftWrapper>
        <RightWrapper>
          <SearchTopbar
            allContractDetails={allContractDetails}
            setAllContractDetails={setAllContractDetails}
          />
          <Routes>
            <Route
              path="/"
              element={<Dashboard allContractDetails={allContractDetails} />}
            />
            <Route
              path={Router.DASHBOARD}
              element={<Dashboard allContractDetails={allContractDetails} />}
            />
            <Route
              path={Router.CREATENFTS}
              element={<CreateNfts allContractDetails={allContractDetails} />}
            />
            <Route path={Router.REVENUESTREAMS} element={<Revenuestreams />} />
            <Route path={Router.NFTMINTDATA} element={<NftMintData />} />
            <Route
              path={Router.LISTINGNFTS}
              element={<ListingNft allContractDetails={allContractDetails} />}
            />
            <Route
              path={Router.MANAGECURRENCY}
              element={
                <ManageCurrency allContractDetails={allContractDetails} />
              }
            />
            <Route
              path={Router.WALLET}
              element={
                <Wallet
                  allContractDetails={allContractDetails}
                  setAllContractDetails={setAllContractDetails}
                />
              }
            />
            <Route path="*" element={<Profile />} />
          </Routes>
        </RightWrapper>
      </Container>

      {/* <Footer /> */}
    </Root>
  </userInfoContext.Provider>
    </userProviderContext.Provider>
  );
};

export default App;
